/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.branches.internal

import features.branches.models.Business
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.domain.AsyncUseCase
import features.branches.internal.BranchesUseCase.Params

internal class BranchesUseCase : AsyncUseCase<Business, Params>() {

    internal class Params(
       val overrideHeaders : Map<String, String>? = null,
        val businessId: String
    )

    private val branchesService: BranchesService = BranchesServiceImpl()

    override suspend fun run(params: Params): Result<Business> {
        return branchesService.getBusinessBranches(
            overrideHeaders = params.overrideHeaders,
            businessId = params.businessId
        )
    }
}
